import { render, staticRenderFns } from "./MainTrackingDesktop.vue?vue&type=template&id=0d280083&scoped=true&"
import script from "./MainTrackingDesktop.vue?vue&type=script&lang=ts&"
export * from "./MainTrackingDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./MainTrackingDesktop.vue?vue&type=style&index=0&id=0d280083&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d280083",
  null
  
)

export default component.exports